import { InjectionToken, Provider, EnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';

export interface AzureADConfig {
  clientId: string;
  tenantId: string;
  redirectUri?: string;
  postLogoutRedirectUri?: string;
}

export interface IMCAuthConfig {
  apiUrl: string;
  azureAD?: AzureADConfig;
  sessionTimeoutMinutes?: number;
  storagePrefix?: string;
  loginRoute?: string;
  unauthorizedRoute?: string;
  requireAdmin?: boolean;
}

export const IMC_AUTH_CONFIG = new InjectionToken<IMCAuthConfig>('IMC_AUTH_CONFIG');

/**
 * Provide IMC Auth configuration and services
 */
export function provideIMCAuth(config: IMCAuthConfig): (Provider | EnvironmentProviders)[] {
  return [
    { provide: IMC_AUTH_CONFIG, useValue: config },
    provideHttpClient(withInterceptors([authInterceptor]))
  ];
}
